import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const TableLoader = () => {
  return (
    <>
      <TableContainer className="table-loader grey-th">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
              <TableCell>
                <p className="sm"></p>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableLoader;
